import React from 'react';
import { Container, Flex, Heading, Text } from '@chakra-ui/react';
import MemberHeroSection from '@/components/membership/MemberHeroSection';

const linksData = [
  {
    id: 'aifs-1',
    date: '17th July 2025',
    text: 'SFA Operating guidelines on framework for Category I and II Alternative Investment Funds to create encumbrance on their holding of equity of investee companies',
    link: 'https://static.levocdn.com/WGLBUT82/ImplementationstandardsforframeworkforCategoryIandIIAlternativeInvestmentFundstocreateencumbranceontheirholdingofequityofinvesteecompanies-k5KVuTxEpIeRH.pdf',
  },
  {
    id: 'aifs-2',
    date: '26th April 2024',
    text: ' Framework for Category I and II Alternative Investment Funds(AIFs) to create encumbrance on their holding of equity of investee companies',
    link: 'https://static.levocdn.com/WGLBUT82/FrameworkforCategoryIandIIAlternativeInvestmentFundsAIFstocreateencumbranceontheirholdingofequityofinvesteecompanies-dO4xwpc2JmBu.pdf',
  },
];

const FrameCategoryAifs = () => (
  <Flex direction="column" rowGap="20px">
    <MemberHeroSection
      title={
        <Heading
          as="h1"
          variant="headingText"
          color="text.headingWhite"
          fontSize={{ xs: '36px', sm: '60px' }}
          textAlign={{ xs: 'left', sm: 'left' }}
        >
          Framework for Category I and II Alternative Investment Funds(AIFs) to
          create encumbrance on their holding of equity of investee companies
        </Heading>
      }
      type="about-us"
    />
    <Container
      maxW="container.xl"
      pt={{ xs: '50px', md: '50px' }}
      pb={{ xs: '50px', md: '50px' }}
      as="section"
      id="info"
      scrollMarginTop="140px"
    >
      <Flex direction="column" gap="2">
        {linksData.map((item) => (
          <Flex
            key={item.id}
            direction={{ base: 'column', md: 'row' }}
            cursor="pointer"
            gap={{ md: '5' }}
            onClick={() => {
              window.open(item?.link, '_blank');
            }}
          >
            <Flex minWidth="200px">
              {item?.date ? (
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item?.date}
                </Text>
              ) : (
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item?.text}
                </Text>
              )}
              {item.date && (
                <Text
                  display={{ base: 'block', md: 'none' }}
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  :&nbsp;
                </Text>
              )}
            </Flex>
            {item.date && (
              <Flex>
                <Text
                  display={{ base: 'none', md: 'block' }}
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  :&nbsp;
                </Text>
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item.text}
                </Text>
              </Flex>
            )}
          </Flex>
        ))}
      </Flex>
    </Container>
  </Flex>
);

export default FrameCategoryAifs;
